<template>
  <div class="py-6">
    <div ref="mainTable" id="pdf" class="p-8 container mx-auto bg-white">
      <div class="w-full border-2 bc-clr bg-white">
        <div class="flex items-center borderfty pb-3 justify-center">
          <p class="text-xl font-semibold overall-col">TAX INVOICE</p>
        </div>
        <div class="flex w-full justify-between border-b-2 bc-clr px-3">
          <div class="flex items-center gap-2">
            <div class="flex px-4 py-5 h-full borderight">
              <img :src="getImage" class="object-contain h-12" />
            </div>
            <div class="p-2">
              <h6 class="text-xl font-semibold text-gray mb-1">
                {{ selectedProject.displayName }}
              </h6>

              <p class="text-sm overall-col">
                {{ brandProfile.contactDetails.address }}
              </p>
              <div class="mt-2">
                <p class="text-sm overall-col">
                  <span class="font-semibold">GSTIN:</span> 36AAATN1283C3ZU
                </p>
                <p class="text-sm overall-col pt-1">
                  <span class="font-semibold">Website:</span>
                  <span class="text-underline cursor-pointer">
                    www.nationalhrd.org</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-2 bc-clr border-b-2 mb-4 mt-6">
          <div class="bc-clr border-r-2">
            <div class="flex borderfty px-2 w-full mb-2">
              <div class="w-1/2 borderight">
                <p class="font-semibold overall-col">Invoice No.:</p>
              </div>
              <div class="w-1/2 px-2">
                <p class="overall-col">{{ selectedOrder.invoiceId }}</p>
              </div>
            </div>
            <div class="flex borderfty px-2 w-full mb-2">
              <div class="w-1/2 borderight">
                <p class="font-semibold overall-col">Date:</p>
              </div>
              <div class="w-1/2 px-2">
                <p class="overall-col">
                  {{ new Date(selectedOrder.createdAt).toDateString() }}
                </p>
              </div>
            </div>
            <!-- <div class="flex px-2 w-full">
              <div class="w-1/2 borderight">
                <p class="font-semibold overall-col">Place of Supply:</p>
              </div>
              <div class="w-1/2 px-2">
                <p class="overall-col">Hello</p>
              </div>
            </div> -->

            <!-- <div class="flex w-full">
              <div class="w-1/2">
                <p>Name:</p>
              </div>
              <div class="w-1/2">
                <p class="font-semibold">
                 
                  {{ invoiceData.name ? invoiceData.name : "" }}
                </p>
              </div>
            </div>
            <div class="flex w-full">
              <div class="w-1/2">
                <p>Address:</p>
              </div>
              <div class="w-1/2">
                <p class="font-semibold">
                  {{ invoiceData.flat ? invoiceData.flat + "," : "" }}
                  {{ invoiceData.area + "," ? invoiceData.area : ""
                  }}{{ invoiceData.landmark ? invoiceData.landmark + "," : ""
                  }}{{ invoiceData.city ? invoiceData.city + "," : ""
                  }}{{ invoiceData.state ? invoiceData.state + " - " : ""
                  }}{{ invoiceData.pincode ? invoiceData.pincode + "," : "" }}
                </p>
              </div>
            </div> -->
          </div>
          <div class="px-3 py-1">
            <div class="w-full">
              <div class="w-1/2">
                <p class="overall-col">Bill to:</p>
              </div>
              <div class="">
                <p class="overall-col">
                  {{ selectedOrder.userData.fullName }}
                </p>
                <p class="overall-col">
                  E-2022, Workafella AK Estate, Near DHL Office Kotak bank,<br />
                  LBS Road, Goregaon west Mumbai 400043 India
                </p>
                <!-- <p class="overall-col">GSTIN: AND4455DWPD5545</p> -->
                <p class="overall-col">
                  Phone: {{ selectedOrder.userData.mobile }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <table style="width: 100%" class="nowpdf">
            <tr class="lastpdfg">
              <th class="pdf news">Products</th>
              <th class="pdf">Quantity</th>
              <th class="pdf">Price</th>
              <th class="pdf">Discounted Price</th>
              <!-- <th class="pdf">Tax Amount</th> -->
              <th class="pdf">IGST %</th>
              <th class="pdf">IGST Amt</th>
              <!-- <th class="pdf" v-if="invoiceData.state === registeredState">
                CGST %
              </th>
              <th class="pdf" v-if="invoiceData.state === registeredState">
                CGST Amount
              </th>
              <th class="pdf" v-if="invoiceData.state === registeredState">
                SGST %
              </th>
              <th class="pdf" v-if="invoiceData.state === registeredState">
                SGST Amount
              </th> -->
              <th class="new-pdfg">Total</th>
            </tr>

            <tr
              class="lastpdfg"
              v-for="(item, index) in selectedOrder.item"
              :key="`${item}+ ${index}`"
            >
              <!-- <td class="lastpdf">45</td> -->
              <td class="news pdf lastpdf fsize12 overall-col">
                {{ item.productName }}
              </td>

              <td class="pdf lastpdf">
                <p class="fsize12 overall-col">{{ item.quantity }}</p>
              </td>
              <td class="pdf lastpdf">
                <p class="fsize12 overall-col">
                  <!-- {{ item.variationId.actualPrice }} -->
                  {{ item.actualPrice }}
                </p>
              </td>
              <!-- <td class="pdf lastpdf" v-if="item.variationId.discountedPrice"> -->
              <td class="pdf lastpdf" v-if="item.discountedPrice">
                <p class="fsize12 overall-col">
                  <!-- {{ item.variationId.discountedPrice }} -->
                  {{ item.discountedPrice }}
                </p>
              </td>
              <td class="pdf lastpdf" v-else>
                <p class="fsize12 overall-col">-</p>
              </td>
              <!-- <td class="pdf lastpdf">-</td> -->
              <td class="pdf lastpdf">
                <p class="fsize12 overall-col">{{ item.GST }}%</p>
              </td>
              <td class="pdf lastpdf" v-if="item.discountedPrice">
                <p class="fsize12 overall-col">
                  {{ ((item.discountedPrice / 100) * item.GST).toFixed(2) }}
                </p>
              </td>
              <td class="pdf lastpdf" v-else>
                <p class="fsize12 overall-col">
                  {{ ((item.actualPrice / 100) * item.GST).toFixed(2) }}
                </p>
              </td>
              <!-- <td
                class="pdf lastpdf"
                v-if="invoiceData.state === registeredState"
              >
                <p class="fsize12 overall-col">9%</p>
              </td>
              <td
                class="pdf lastpdf"
                v-if="invoiceData.state === registeredState"
              >
                <p class="fsize12 overall-col">12545</p>
              </td>
              <td
                class="pdf lastpdf"
                v-if="invoiceData.state === registeredState"
              >
                <p class="fsize12 overall-col">9%</p>
              </td>
              <td
                class="pdf lastpdf"
                v-if="invoiceData.state === registeredState"
              >
                <p class="fsize12 overall-col">658</p>
              </td> -->
              <td class="startpdf" v-if="item.discountedPrice">
                <p class="fsize12 overall-col">
                  {{
                    parseFloat(item.discountedPrice) +
                    parseFloat(
                      ((item.discountedPrice / 100) * item.GST).toFixed(2)
                    )
                  }}
                </p>
              </td>
              <td class="startpdf" v-else>
                <p class="fsize12 overall-col">
                  {{
                    parseFloat(item.actualPrice) +
                    parseFloat(((item.actualPrice / 100) * item.GST).toFixed(2))
                  }}
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="flex w-full border-t-2 bc-clr">
          <div class="w-3/5 py-3">
            <p class="text-sm overall-col">Total In Words</p>
            <p class="font-semibold capitalize overall-col text-sm">
              {{ getWords(grandTotal) }} Rupees Only/-
            </p>
            <p class="mt-2 uppercase overall-col text-sm">
              Looking Forward for your business
            </p>
            <p class="mt-2 text-sm overall-col">Terms & Condition applied</p>
          </div>
          <div class="w-2/5">
            <div
              class="px-3 py-3 border-l-2 border-b-2 bc-clr flex w-full justify-between"
            >
              <p class="overall-col">Grand Total</p>
              <p class="font-semibold overall-col">
                Rs. {{ grandTotal.toFixed(2) }}/-
              </p>
            </div>
            <div class="border-l-2 bc-clr">
              <div class="flex justify-between items-center w-full px-5">
                <!-- <img
                  src="@/assets/conference/logo.png"
                  class="w-32 object-contain h-16"
                />
                <img
                  src="@/assets/conference/sign.png"
                  class="w-full object-contain h-16"
                /> -->
              </div>
              <p class="px-3 overall-col py-1 text-center">
                Authorised Signature
              </p>
            </div>
          </div>
        </div>
        <div class="w-full items-center gap-3 border-t-2 mt-4 bc-clr">
          <div class="flex mb-2 h-full borderight">
            <p class="text-underline overall-col font-semibold">
              Bank Deatails :
            </p>
            <!-- <p class="w-4/5 font-semibold">
            bscjebejekejrkbongnoinmxpqwjnoihcnoimiudmklmkdjmhncmh
          </p> -->
          </div>
          <div class="">
            <div class="flex w-full gap-2 items-center mt-1">
              <p class="text-sm font-semibold overall-col">Company's PAN :</p>
              <p class="text-sm overall-col">AAATN1283C</p>
            </div>
            <div class="flex w-full gap-2 items-center mt-2">
              <p class="text-sm font-semibold overall-col">Beneficery Name :</p>
              <p class="text-sm overall-col">
                National HRD Network- National Conference
              </p>
            </div>
            <div class="flex w-full gap-2 items-center mt-2">
              <p class="text-sm font-semibold overall-col">Bank Name :</p>
              <p class="text-sm overall-col">ICICI Bank Ltd</p>
            </div>
            <div class="flex w-full gap-2 items-center mt-2">
              <p class="text-sm font-semibold overall-col">
                Bank Account No. :
              </p>
              <p class="text-sm overall-col">031401005516</p>
            </div>
            <div class="flex w-full gap-2 items-center mt-2">
              <p class="text-sm font-semibold overall-col">IFSC Code No. :</p>
              <p class="text-sm overall-col">ICICI0000314</p>
            </div>
            <!-- <p class="mt-4">
            e-Invoicing details(s) generated from the goverment e-Invoicing
            System.
          </p> -->
          </div>
        </div>
        <!-- <div class="h-60 bc-clr border-t-2"></div> -->
      </div>
    </div>
    <div class="text-center my-8">
      <vs-button class="px-12" @click="generateReport">Download</vs-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import html2pdf from "html2pdf.js";
const numberToWords = require("number-to-words");
export default {
  data() {
    return {
      registeredState: "Telangana",
      amount: "",
      // selectedOrder: {},
      tableData: [
        {
          sr: "1",
          item: "CC Ice on Ice Deatangling Shampoo 16 oz,",
          hsn: "3330032",
          expdate: "18/09/2022",
          qty: "3,00 Nos.",
          mrp: "1,939.00",
          amnt: "5,9937.00",
          disc: "30.00%",
          taxamnt: "3,557.54",
          cgstperc: "18%",
          cgstamnt: "640.36",
          sgstperc: "18%",
          sgstamnt: "640.36",
          total: "4,293.00,",
        },
        {
          sr: "2",
          item: "CC Ice on Ice Deatangling Shampoo 16 oz,",
          hsn: "3330032",
          expdate: "18/09/2022",
          qty: "3,00 Nos.",
          mrp: "1,939.00",
          amnt: "5,9937.00",
          disc: "30.00%",
          taxamnt: "3,557.54",
          cgstperc: "18%",
          cgstamnt: "640.36",
          sgstperc: "18%",
          sgstamnt: "640.36",
          total: "4,293.00,",
        },
        {
          sr: "3",
          item: "CC Ice on Ice Deatangling Shampoo 16 oz,",
          hsn: "3330032",
          expdate: "18/09/2022",
          qty: "3,00 Nos.",
          mrp: "1,939.00",
          amnt: "5,9937.00",
          disc: "30.00%",
          taxamnt: "3,557.54",
          cgstperc: "18%",
          cgstamnt: "640.36",
          sgstperc: "18%",
          sgstamnt: "640.36",
          total: "4,293.00,",
        },
        {
          sr: "4",
          item: "CC Ice on Ice Deatangling Shampoo 16 oz,",
          hsn: "3330032",
          expdate: "18/09/2022",
          qty: "3,00 Nos.",
          mrp: "1,939.00",
          amnt: "5,9937.00",
          disc: "30.00%",
          taxamnt: "3,557.54",
          cgstperc: "18%",
          cgstamnt: "640.36",
          sgstperc: "18%",
          sgstamnt: "640.36",
          total: "4,293.00,",
        },
      ],
      invoiceData: {},
      data1: {},
    };
  },
  components: {
    numberToWords,
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("EcomOrder", ["selectedOrder"]),
    getImage() {
      return this.brandProfile.primaryLogo
        ? `${this.$imageURL}${this.brandProfile.primaryLogo}`
        : "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/icecream.png";
    },
    grandTotal() {
      let totalPrice = 0;
      for (let i = 0; i < this.selectedOrder.item.length; i++) {
        if (this.selectedOrder.item[i].discountedPrice) {
          totalPrice =
            totalPrice +
            (parseFloat(this.selectedOrder.item[i].discountedPrice) +
              parseFloat(
                (
                  (this.selectedOrder.item[i].discountedPrice / 100) *
                  this.selectedOrder.item[i].GST
                ).toFixed(2)
              ));
        } else {
          totalPrice =
            totalPrice +
            (parseFloat(this.selectedOrder.item[i].actualPrice) +
              parseFloat(
                (
                  (this.selectedOrder.item[i].actualPrice / 100) *
                  this.selectedOrder.item[i].GST
                ).toFixed(2)
              ));
        }
      }
      return totalPrice;
    },
  },
  methods: {
    getWords(data) {
      return numberToWords.toWords(data);
    },
    generateReport() {
      html2pdf(this.$refs.mainTable, {
        margin: 0,
        filename: "invoice.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 4,
          // width: document.getElementById("pdf").offsetWidth,
          // height: document.getElementById("pdf").offsetHeight,
          windowWidth: window.innerWidth,
        },
        jsPDF: { unit: "in", orientation: "landscape", format: "a4" },
      });
    },
  },
  mounted() {
    // this.selectedOrder = this.$store.state.EcomOrder.selectedOrder;
    console.log(this.selectedProject);
    console.log(this.brandProfile);
    console.log(this.selectedOrder);
  },
};
</script>

<style>
.bg-l-grey {
  background-color: #ededed;
}
.bc-clr {
  border-color: #626262;
}
.style-tbl > .el-table__header-wrapper > table > thead > tr > th {
  color: black;
  font-size: 15px;
  font-weight: 600;
}
.style-tbl > .el-table__body-wrapper > table > tbody > tr > td > .cell {
  color: black;
  font-size: 15px;
  /* font-weight: 600; */
}

.pdf {
  color: #000 !important;

  text-align: center;
}
.lastpdf {
  color: #000 !important;
  border-bottom: none;
  padding-top: 5px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
.lastpdfg {
  color: #000 !important;
  border: none !important;
  padding-top: 5px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
/* .new-pdfg {
  border-bottom: 1px solid #626262 !important;
} */

.lastpdfg th {
  background: #f4f5f6;
  padding: 12px;
}
.startpdf {
  color: #000 !important;

  padding-top: 5px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
.nowpdf {
  color: #000 !important;
  border: 1px solid #80808038;
  text-align: center;
}
.news {
  width: 280px !important;
  color: #000 !important;
}
.overall-col {
  color: #6e6b7b !important;
}
.text-underline {
  text-decoration: underline;
}
</style>
